import React from 'react';
import {
    Box,
    IconButton,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface DetailScreenHeaderProps {
    title: React.ReactNode;
    onClose: () => void;
    actions?: React.ReactNode;
    subtitle?: React.ReactNode;
}

const headerButtonSx = {
    minHeight: 44,
    minWidth: 44,
    border: '1px solid',
    borderColor: 'divider',
};

const DetailScreenHeader: React.FC<DetailScreenHeaderProps> = ({
    title,
    onClose,
    actions,
    subtitle,
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                px: { xs: 2, sm: 3 },
                pt: { xs: 2, sm: 2.5 },
                pb: subtitle ? 1.5 : 1.25,
                borderBottom: '1px solid',
                borderColor: 'divider',
                backgroundColor: 'background.paper',
            }}
        >
            <Stack spacing={subtitle ? 1.25 : 0}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        gap: 1.5,
                    }}
                >
                    <Box sx={{ minWidth: 0 }}>
                        <Typography
                            variant={isMobile ? 'h6' : 'h5'}
                            sx={{
                                fontWeight: 800,
                                lineHeight: 1.2,
                                overflowWrap: 'anywhere',
                                wordBreak: 'break-word',
                            }}
                        >
                            {title}
                        </Typography>
                    </Box>

                    <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
                        {actions}
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            sx={headerButtonSx}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                </Box>

                {subtitle}
            </Stack>
        </Box>
    );
};

export default DetailScreenHeader;
